import ListPage, { useList } from '@/components/BaseList';
import { usePermission } from '@/common/hooks/index';
import { httpPageOdsNhsaDrug } from '@/services/datamanagement';
import React from 'react';
import SearchForm from './components/SearchForm';
import styles from './index.less';

/**
 * 医保药品数据库 (西药+中成药)
 * @returns
 */
const PcMedicine: React.FC = () => {
  const { permission } = usePermission();

  const list = useList();
  const fetchAPi = (params: any) => {
    const req: any = {
      // ...params,
      limit: params.pageSize,
      pageNo: params.current,
      cond: {
        registeredName: params.registeredName,
        company: params.company,
        approvalNumber: params.approvalNumber,
      },
      orders: [
        // {
        //   direction: params.direction === 'ascend' ? 'ASC' : 'DESC',
        //   property: params.property || 'createTime',
        // },
      ],
    };

    return httpPageOdsNhsaDrug(req).then((res) => {
      return {
        listData: res.data,
        pagination: {
          current: res.pageIndex,
          pageSize: res.pageSize,
          total: res.totalCount,
        },
      };
    });
  };

  const changetable = (pagination: any, filters: any, sorter: any) => {
    const property: string = sorter.columnKey;
    list.current.fetchListData({ direction: sorter.order, property });
  };

  const columns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 100,
      children: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          width: 100,
        },
      ],
    },
    {
      title: '药品代码',
      dataIndex: 'code',
      key: 'code',
      width: 300,
      children: [
        {
          title: 'code',
          dataIndex: 'code',
          key: 'code',
          width: 300,
        },
      ],
    },
    {
      title: '注册名称',
      dataIndex: 'registeredName',
      key: 'registeredName',
      children: [
        {
          title: 'registeredName',
          dataIndex: 'registeredName',
          key: 'registeredName',
        },
      ],
    },
    {
      title: '商品名称',
      dataIndex: 'name',
      key: 'name',
      children: [
        {
          title: 'name',
          dataIndex: 'name',
          key: 'name',
        },
      ],
    },
    {
      title: '剂型',
      dataIndex: 'dosage',
      key: 'dosage',
      width: 200,
      children: [
        {
          title: 'dosage',
          dataIndex: 'dosage',
          key: 'dosage',
          width: 200,
        },
      ],
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      width: 200,
      children: [
        {
          title: 'spec',
          dataIndex: 'spec',
          key: 'spec',
          width: 200,
        },
      ],
    },
    {
      title: '包装材质',
      dataIndex: 'materialName',
      key: 'materialName',
      width: 200,
      children: [
        {
          title: 'materialName',
          dataIndex: 'materialName',
          key: 'materialName',
          width: 200,
        },
      ],
    },
    {
      title: '最小包装数量',
      dataIndex: 'minPackageNum',
      key: 'minPackageNum',
      width: 200,
      children: [
        {
          title: 'minPackageNum',
          dataIndex: 'minPackageNum',
          key: 'minPackageNum',
          width: 200,
        },
      ],
    },
    {
      title: '最小制剂单位',
      dataIndex: 'minUnit',
      key: 'minUnit',
      width: 200,
      children: [
        {
          title: 'minUnit',
          dataIndex: 'minUnit',
          key: 'minUnit',
          width: 200,
        },
      ],
    },
    {
      title: '最小包装单位',
      dataIndex: 'packageUnit',
      key: 'packageUnit',
      width: 200,
      children: [
        {
          title: 'packageUnit',
          dataIndex: 'packageUnit',
          key: 'packageUnit',
          width: 200,
        },
      ],
    },
    {
      title: '药品企业',
      dataIndex: 'companyName',
      key: 'companyName',
      width: 300,
      children: [
        {
          title: 'companyName',
          dataIndex: 'companyName',
          key: 'companyName',
          width: 300,
        },
      ],
    },
    {
      title: '批准文号',
      dataIndex: 'approvalCode',
      key: 'approvalCode',
      width: 300,
      children: [
        {
          title: 'approvalCode',
          dataIndex: 'approvalCode',
          key: 'approvalCode',
          width: 300,
        },
      ],
    },
    {
      title: '药品本位码',
      dataIndex: 'standardCode',
      key: 'standardCode',
      children: [
        {
          title: 'standardCode',
          dataIndex: 'standardCode',
          key: 'standardCode',
        },
      ],
    },
    {
      title: '国家医保药品目录',
      dataIndex: 'md5',
      key: 'md5',
      className: styles.bg,
      children: [
        {
          title: '甲乙类（insuranceType）',
          dataIndex: 'insuranceType',
          key: 'insuranceType',
          className: styles.bg,
        },
        {
          title: '编号（productCode）',
          dataIndex: 'productCode',
          key: 'productCode',
          className: styles.bg,
        },
        {
          title: '药品名称（productName）',
          dataIndex: 'productName',
          key: 'productName',
          className: styles.bg,
        },
        {
          title: '剂型（productDosage）',
          dataIndex: 'productDosage',
          key: 'productDosage',
          className: styles.bg,
        },
        {
          title: '备注（remark）',
          dataIndex: 'remark',
          key: 'remark',
          className: styles.bg,
        },
      ],
    },
  ];

  return (
    <div>
      <ListPage
        list={list}
        fetchApi={fetchAPi}
        columns={columns}
        SearchForm={permission.sysSearchBtn && SearchForm}
        BodyProps={{
          scroll: { x: 4000 },
          onChange: (pagination: any, filters: any, sorter: any) => {
            changetable(pagination, filters, sorter);
          },
        }}
      />
    </div>
  );
};

export default PcMedicine;
